export const Routes = {
  login: '/login',
  workshop: '/talleres',
  users: '/users',
  providers: '/providers',
  devices: '/devices',
  workshopTypes: '/workshopTypes',
  profile: '/profile',
  help: '/help',
  home: '/home',
  dashboard: '/dashboard'
} as const;
